import "./index.css"
import React, { useState, useEffect } from 'react';
import { fetchAccountData } from "../../functions/fetchAccountData";
import Button from '../button';

function Table({openAccountDeletionPortal,openSettings}) {
  const [userDetails,setUserDetails] = useState({"email":"","inputs":"","date":""});
  const [errorState, changeErrorState] = useState({errorStatus:false,errorMessage:null});
  useEffect(() => {
    fetchAccountData(setUserDetails);
  }, []);

  const handleClick =() =>{ 
    window.location.href = '/reset-password';
  }

const logout = () => {
  let name = 'mako_auth';
  let cookies = document.cookie.split(';');
  let cookieValue = null;

  for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i].trim();
      if (cookie.startsWith(name + '=')) {
          cookieValue = cookie.substring((name + '=').length);
          break; // Exit the loop once the cookie is found
      }
  }

  // Delete the cookie
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  window.location.href = "/"; // Redirect to the "/input" page
  // Return the cookie value if it was found
  return cookieValue;
};

const changePassword = () =>{
    window.location.href = "/reset-password"
}

const handleOpenSetting = (context) =>{
  openSettings(context);
  
}

  return <><div className="table-holder"><div className="table small-text">
    <div className="label">Email</div>
    <div className='content'>{userDetails.email}</div>
    <div className="label"># of inputs</div>
    <div className='content'>{userDetails.inputs}</div>
    <div className="label">Start date</div>
    <div className='content'>{new Date(userDetails.date).toUTCString()}</div>
    <div className="label">Persona</div>
    <div className="editable-table-content">
      <div className='content'>{userDetails.persona}</div>
      <Button text="Change persona" addedFunction={handleOpenSetting} params="persona"></Button>
    </div>
    <div className="label">ICP</div>
    <div className="editable-table-content">
    <div className='content'>{userDetails.icp}</div>
    <Button text="Change ICP" addedFunction={handleOpenSetting} params="ICP"></Button>
    </div>
  </div>
  <div id="error-message" className="small-text" style={{ color: errorState.errorStatus ? 'red' : 'green' }}>{errorState.errorMessage}</div>
  </div>
  <div className="logout-button-holder">
  <Button text='Change password' addedFunction={changePassword}/>
  <Button text='Logout' addedFunction={logout}/>
  <Button text='Delete account' addedFunction={openAccountDeletionPortal} />
  </div>
  </>
  }

export default Table;